@if (page?.sections) {
  <app-sections [data]="page.sections"></app-sections>
}


<div *ngIf="sponsors$ | async as sponsors">
  <app-sponsor-banner *ngIf="page?.showSponsors" [data]="{sponsors: sponsors}"></app-sponsor-banner>
</div>